"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _contains = _interopRequireDefault(require("lodash/fp/contains"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _compare = require("@active/core/address/compare");
var _parseForRender = _interopRequireDefault(require("../utils/parseForRender"));
var addressPropName = ['line1', 'line2', 'city', 'stateProvince', 'postalCode', 'country'];
var negate = function negate(val) {
  return !val;
};
var getDiffAddressProperty = function getDiffAddressProperty(source, suggestion) {
  return Object.keys(suggestion).filter((0, _compose["default"])(negate, (0, _compare.isFieldEqual)(source)(suggestion)));
};
var getDiffAddressClassName = function getDiffAddressClassName(diffAddressProps, addressProp) {
  return (0, _contains["default"])(addressProp)(diffAddressProps) ? 'suggestion-address-highlight' : '';
};
var getAddressElement = function getAddressElement(suggestion, diffAddress) {
  return addressPropName.reduce(function (elements, key, i) {
    var value = (0, _prop["default"])(key)(suggestion);
    var El = key === 'country' ? 'div' : 'span';
    var className = getDiffAddressClassName(diffAddress, key);
    var addressEl = /*#__PURE__*/_react["default"].createElement(El, {
      key: key,
      className: className
    }, value);
    var commaEl = /*#__PURE__*/_react["default"].createElement("span", {
      key: "".concat(key, "-comma"),
      className: "suggestion-comma"
    }, ",");
    if (!value) {
      return elements;
    }
    return i === 0 || El === 'div' ? elements.concat(addressEl) : elements.concat(commaEl).concat(addressEl);
  }, []);
};
var AddressSuggestion = function AddressSuggestion(_ref) {
  var source = _ref.source,
    suggestion = _ref.suggestion,
    onUseSuggestion = _ref.onUseSuggestion,
    title = _ref.title,
    useSuggestionLinkText = _ref.useSuggestionLinkText;
  if (!source || !suggestion) {
    return null;
  }
  var diffAddress = getDiffAddressProperty(source, suggestion);
  var parsedSuggestion = (0, _parseForRender["default"])(suggestion);
  var AddressElement = getAddressElement(parsedSuggestion, diffAddress);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "suggestion-address"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: "suggestion-title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "suggestion-address-list"
  }, AddressElement), /*#__PURE__*/_react["default"].createElement("button", {
    className: "suggestion-link",
    onClick: function onClick() {
      onUseSuggestion && onUseSuggestion(suggestion);
    }
  }, useSuggestionLinkText));
};
AddressSuggestion.defaultProps = {
  title: 'Suggested address',
  useSuggestionLinkText: 'Use this address'
};
var _default = exports["default"] = AddressSuggestion;